namespace Nobox.Administration {
    export interface TenantListRequest extends Serenity.ListRequest {
        View?: number;
        Member?: number;
    }
}
